import React from 'react';
import s from './PrivacyPolicy.module.css';

interface PrivacyPolicyModalProps {
    isOpen: boolean;
    onClose: () => void;
    content: string;
    renderContent: (content: string) => React.ReactNode;
}

export const PrivacyPolicy: React.FC<PrivacyPolicyModalProps> = ({
                                                                     isOpen,
                                                                     onClose,
                                                                     content,
                                                                     renderContent
                                                                 }) => {
    if (!isOpen) return null;

    return (
        <div className={s.overlay} onClick={onClose}>
            <div className={s.modal} onClick={(e) => e.stopPropagation()}>
                <button className={s.closeButton} onClick={onClose}>×</button>
                <h2 className={s.title}>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h2>
                <div className={s.content}>
                    {renderContent(content)}
                </div>
            </div>
        </div>
    );
};